let manageTasks = function(i, index) {
    this.m = {
        show: true,
        component: 'manageTasks',
        data: [i, index]
    };
    this.$store.commit('core/setOpenModal', this.m);
};
export default manageTasks;
